export default __webpack_public_path__ + "static/media/MAXWELL_SmCps_CND_BK.5a92a348.ttf";